import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import EstateMpProvider from "@/core/data-provider/data-mp/estate/estate-mp-provider.ts";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import { EstateInfo } from "@/domains/estate/slice";
import toast from "@/domains/toasts/helpers/toast";

export default function useToggleLockEstate() {
  const { t } = useTranslation("estate");

  const toggleLockEstate = useCallback(
    async (estate: EstateInfo, successCallback: () => void) => {
      if (estate?.id) {
        const response = await EstateMpProvider.lock(estate.id, !estate.isLocked);
        if (response instanceof RpcMpProviderSuccessResponse) {
          successCallback();
        } else if (response.message === "TOO_FAR_ERROR") {
          toast.error(t("estate.errors.TOO_FAR_ERROR"));
        } else {
          console.log("Error lock/unlock estate");
        }
      }
    },
    [t],
  );

  return { toggleLockEstate };
}
